import { http } from './http';
import { enterprise } from 'config/system';

export class ActiveDirectoryLoginResponse {
  status: boolean;
  mbr_id?: string;
  accessToken?: string;
  refreshToken?: string;
  errmsg?: string;
  constructor(
    status: boolean,
    errmsg?: string,
    mbr_id?: string,
    accessToken?: string,
    refreshToken?: string
  ) {
    this.status = status;
    this.mbr_id = mbr_id;
    this.errmsg = errmsg;
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
  }
}

export async function activeDirectoryLogin(
  svid: string,
  id: string,
  password: string,
  token?: string,
): Promise<ActiveDirectoryLoginResponse> {
  try {
    const url = http.url.api(`/admin/adauth/login`, 1);
    const body = new FormData();
    body.append('svid', svid);
    body.append('account', id);
    body.append('password', password);
    if (token) {
      body.append('recaptcha_token', token);
    }
    const res = await http.post(url, { body });
    const { status, data } = await http.handleResponse(res);

    return new ActiveDirectoryLoginResponse(
      status,
      'no error',
      data.mbr_id,
      data.access_token,
      data.refresh_token
    );
  } catch (error) {
    return new ActiveDirectoryLoginResponse(
      error.status,
      error.errmsg,
      error.data && error.data.mbr_id,
      error.data && error.data.access_token,
      error.data && error.data.refresh_token,
    );
  }
}

// 直接寫死聯發科的 BS 登入網址，完成後導回問卷頁
export function getBSUrl(name: string, svid: string): string {
  switch (name) {
    case 'mediatek-dev':
      return `https://mtksurveyapt7.mediatek.inc:9443/v1/aad/login?redirect_url=${encodeURIComponent(
        `https://mediatek-dev.svy.do/s/${svid}`
      )}`;
    case 'mediatek-uat':
      return `https://mtksurveyapt7.mediatek.inc:9443/v1/aad/login?redirect_url=${encodeURIComponent(
        `https://mtksurveyapt5.mediatek.inc:9443/s/${svid}`
      )}`;
    case 'mediatek':
      return `https://mtksurveyact.mediatek.com/v1/aad/login?redirect_url=${encodeURIComponent(
        `https://mtksurvey.mediatek.com/s/${svid}`
      )}`;
    default:
      return '';
  }
}

export async function activeDirectoryAutoLogin(
  svid: string
): Promise<ActiveDirectoryLoginResponse> {
  try {
    const url = http.url.api(`/admin/adauth/auto-login`, 1);
    const body = new FormData();
    body.append('svid', svid);
    const res = await http.post(url, { body });
    const { status, data } = await http.handleResponse(res);
    return new ActiveDirectoryLoginResponse(
      status,
      'no error',
      data.mbr_id,
      data.access_token,
      data.refresh_token
    );
  } catch (error) {
    // auto-logn 失敗直接導去 BS 登入
    if (enterprise.exactName) {
      window.location.href = getBSUrl(enterprise.exactName, svid);
    }
    // 這是舊的邏輯，聯發科的問卷不會執行到這裡
    return new ActiveDirectoryLoginResponse(error.status, error.errmsg);
  }
}

export async function submit_available(
  svid: string,
  mbr_id: string
): Promise<ActiveDirectoryLoginResponse> {
  try {
    const url = http.url.api(`/admin/adauth/submit-available`, 1);
    const body = new FormData();
    body.append('svid', svid);
    body.append('mbr_id', mbr_id);
    const res = await http.post(url, { body });
    const { status } = await http.handleResponse(res);

    return new ActiveDirectoryLoginResponse(status, 'no error');
  } catch (error) {
    return new ActiveDirectoryLoginResponse(error.status, error.errmsg);
  }
}

export async function createToken(
  mbr_id: string,
  email: string,
  name: string
){
  try {
    const url = http.url.api(`/admin/sso/token/create`, 2);
    const body = new FormData();
    body.append('mbr_id', mbr_id);
    body.append('email', email);
    body.append('name', name);

    const res = await http.post(url, { body });
    return await http.handleResponse(res);
  } catch (error) {
    return { status: false }
  }
}
